import { oc } from "@orpc/contract";
import { z } from "zod";

const addressOutputSchema = z.object({
  id: z.string().uuid(),
  addressLine1: z.string(),
  addressLine2: z.string().nullable(),
  locality: z.string(),
  administrativeArea: z.string().nullable(),
  postalCode: z.string().nullable(),
  countryIso31661Alpha2: z.string(),
});

export const getPrimaryAddressContract = oc
  .output(z.object({ address: addressOutputSchema.nullable() }))
  .route({ method: "GET" });

export const UpsertPrimaryAddressInputSchema = z.object({
  addressLine1: z.string().trim().min(1),
  addressLine2: z.string().nullish(),
  locality: z.string().trim().min(1),
  administrativeArea: z.string().nullish(),
  postalCode: z.string().nullish(),
  countryIso31661Alpha2: z.string().length(2),
});

export const upsertPrimaryAddressContract = oc
  .input(UpsertPrimaryAddressInputSchema)
  .output(z.object({ address: addressOutputSchema }))
  .route({ method: "POST" });

export const organizationAddressContracts = {
  getPrimaryAddress: getPrimaryAddressContract,
  upsertPrimaryAddress: upsertPrimaryAddressContract,
} as const;

export type UpsertPrimaryAddressInput = z.infer<
  typeof UpsertPrimaryAddressInputSchema
>;
